<template>
  <div class="container">
    <div class="header">
      <div class="left">
        共 1 首 <span v-if="worksSize">（{{ worksSize }}）</span>
      </div>
    </div>
    <div class="content">
      <div class="item-box">
        <div class="imgBox" @click="handlePlayAudio()">
          <img src="../../assets/images/upload/audioIcon.png" alt="" />
          <img
            v-if="!isPlaying"
            class="icon"
            src="../../assets/images/upload/playIcon.png"
            alt=""
          />
          <img
            v-else
            class="icon"
            src="../../assets/images/upload/pauseIcon.png"
            alt=""
          />
          <audio ref="audioRef" :src="resourceUrl"></audio>
        </div>
        <div class="title">
          <div class="font">
            {{ fileName }}
          </div>
          <div class="line" :class="isPlaying ? 'wave-animation' : ''">
            <img src="../../assets/images/upload/audioLine.png" alt="" />
          </div>
          <div class="desc">
            {{ formatSecondsToHMS(duration) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "audioList",
  props: {
    resourceUrl: {
      type: String,
      default: "",
    },
    worksSize: {
      type: String,
      default: "",
    },
    duration: {
      type: Number,
      default: 0,
    },
    fileName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      fileList: [],
      isPlaying: false,
    };
  },
  methods: {
    handlePlayAudio() {
      this.isPlaying = !this.isPlaying;
      if (this.isPlaying) {
        this.$refs.audioRef.play();
      } else {
        this.$refs.audioRef.pause();
      }
    },
    stopAudio() {
      this.isPlaying = false;
    },
    // 获取音频元素
    getAudioElement() {
      const audioElements = this.$refs.audioRef;
      if (!audioElements) return;
      audioElements.addEventListener("ended", this.stopAudio);
    },
    formatSecondsToHMS(seconds) {
      if (!seconds) return;
      // 计算时分秒
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = Math.floor(seconds % 60);

      // 补零格式化
      return [
        hours.toString().padStart(2, "0"),
        minutes.toString().padStart(2, "0"),
        remainingSeconds.toString().padStart(2, "0"),
      ].join(":");
    },
  },
  mounted() {
    this.getAudioElement();
  },
  beforeDestroy() {
    const audioElements = this.$refs.audioRef;
    if (!audioElements) return;
    this.isPlaying = false;
    audioElements.pause();
    audioElements.removeEventListener("ended", this.stopAudio);
  },
};
</script>

<style lang="scss" scoped>
.container {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    font-weight: 400;
    font-size: 14px;

    .left {
      color: #999999;
      font-size: 12px;
    }

    .right {
      color: #4e89ff;

      span {
        margin-right: 10px;
        cursor: pointer;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}

.content {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  border-radius: 4px;
  margin-bottom: 20px;
  border: 1px solid #e6e6e6;
  width: 80%;
  .item-box {
    height: 80px;
    padding: 5px;
    border-radius: 3px;
    display: flex;
    align-items: center;

    &:last-child {
      margin-right: 0;
    }

    .check-box {
      margin-right: 30px;
      margin-left: 10px;
    }

    .imgBox {
      width: 80px;
      height: 80px;
      cursor: pointer;
      position: relative;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .icon {
        width: 22px;
        height: 20px;
        position: absolute;
        bottom: 10px;
        right: 10px;
      }
    }

    .title {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      margin-left: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      position: relative;
      width: calc(100% - 100px);
      .font {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 90%;
      }
      .line {
        margin-top: 10px;
      }
    }

    .desc {
      // align-self: flex-end;
      // margin-left: auto;
      // margin-right: 20px;
      position: absolute;
      color: #000;
      right: 20px;
      bottom: 10px;
    }
  }
}

.wave-animation {
  animation: wave 5s infinite linear;

  img {
    opacity: 0.8;
  }
}

@keyframes wave {
  0% {
    transform: scaleY(1);
  }

  25% {
    transform: scaleY(0.5);
  }

  50% {
    transform: scaleY(1);
  }

  75% {
    transform: scaleY(0.5);
  }

  100% {
    transform: scaleY(1);
  }
}
</style>
